
import moment from 'moment'
import promoData from '@/data/promo.json'
export default {
  props: {
    page: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      promoData,
      formData: {
        firstName: '',
        lastName: '',
        email: '',
      },
      // You would likely have countdown data here
      // days: 0, hours: 0, minutes: 0, seconds: 0
    };
  },
  computed: {
    headerImage() {
      // This computation remains useful for the background image
      const dotIndex = this.page.thumbnail.lastIndexOf('.');
      const ext = this.page.thumbnail.substring(dotIndex);
      const options = { quality: 80, width: '1920px' }; // Adjust width for full screen
      if (ext === '.jpg' || ext === '.JPG' || ext === '.jpeg' || ext === '.JPEG') {
        options.format = 'webp';
      }
      const imgUrl = this.$img(this.$options.filters.cdn(this.page.thumbnail), options);
      return {
        backgroundImage: `linear-gradient(90deg, rgba(57, 86, 116, 0.95), rgba(57, 86, 116, 0.75)), url('${imgUrl}')`, // Added overlay for text readability
        backgroundSize: 'cover',
        backgroundPosition: 'top',
      };
    },
    ended() {
      // Check if webinarDatetime exists
      if (!promoData.webinarDatetime) {
        console.warn('promoData.webinarDatetime not found. Countdown will not start.');
        return true; // If no webinar date, treat as ended
      }

      const targetDate = moment(promoData.webinarDatetime).tz('Europe/London');
      const todayDate = moment().tz(this.detectedTimezone || 'Europe/London');

      return todayDate.isAfter(targetDate);
    }
  },
  mounted() {

  },
  beforeDestroy() {
    // Clear countdown interval here if needed
  },
  methods: {
    submitForm() {
      // Handle form submission logic here (e.g., API call)
      console.log('Form submitted:', this.formData);
      alert('Form submitted! (Check console for data)');
    },
    // You would add methods for countdown timer logic here
  },
};
